import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, applicantLink, yesNo } from '../../utils/configuredReportFormatters'

export const mobileEventColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'applicant_id',
    label: 'Applicant',
    sortKey: 'fk_applicant_id',
    render: (row) => applicantLink(row.fk_applicant_id ?? row.applicant_id),
  },
  {
    id: 'name',
    label: 'Name',
    render: (row) =>
      display(
        row.name ??
          `${display(row.first_name)} ${display(row.last_name)}`
            .replace(/—/g, '')
            .trim(),
      ),
  },
  { id: 'device', label: 'Device', render: (row) => display(row.device) },
  {
    id: 'app_register',
    label: 'Register',
    render: (row) => yesNo(row.app_register),
  },
  { id: 'app_login', label: 'Login', render: (row) => yesNo(row.app_login) },
  {
    id: 'is_application_complete',
    label: 'Application Filled',
    render: (row) => yesNo(row.is_application_complete),
  },
  { id: 'app_fee', label: 'App Fee', render: (row) => yesNo(row.app_fee) },
  {
    id: 'app_access_fee_full',
    label: 'Access Fee Full',
    render: (row) => yesNo(row.app_access_fee_full),
  },
]
